module.exports = __webpack_public_path__ + "media/qianshou.780e93b0.wav";